export class ProcoreTransactionFilters {
  public ignoreDate: boolean = false;
}
